import React from "react";

const Icon = ({width="18px",height="18px",fill="white",className}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 18 18"
      className={className}
    >
      <mask
        id="mask0_4203_11339"
        style={{ maskType: "alpha" }}
        width={width}
        height={height}
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#D9D9D9" d="M0 0H17.156V17.156H0z"></path>
      </mask>
      <g mask="url(#mask0_4203_11339)">
        <path
          fill={fill}
          d="M4.168 13.983a1.932 1.932 0 01-1.42-.586 1.937 1.937 0 01-.585-1.421H.953V4.51c0-.361.125-.667.375-.917s.556-.375.917-.375h9.733V5.94h1.897l2.31 3.093v2.942h-1.292c0 .557-.196 1.031-.586 1.421-.39.39-.865.586-1.423.586a1.932 1.932 0 01-1.421-.586 1.937 1.937 0 01-.585-1.421H6.177c0 .559-.195 1.033-.586 1.422a1.94 1.94 0 01-1.423.585zm.002-1.073c.262 0 .483-.09.664-.27.18-.181.27-.402.27-.664a.903.903 0 00-.27-.664.903.903 0 00-.664-.271.903.903 0 00-.664.27.903.903 0 00-.27.665c0 .262.09.483.27.664.18.18.402.27.664.27zm-2.145-2.007h.517a1.9 1.9 0 01.66-.666c.287-.179.61-.268.968-.268.35 0 .67.088.962.265.291.177.513.4.666.67h5.108V4.29h-8.66a.21.21 0 00-.152.069.21.21 0 00-.069.151v6.392zm10.86 2.007c.263 0 .484-.09.665-.27.18-.181.27-.402.27-.664a.903.903 0 00-.27-.664.903.903 0 00-.665-.271.903.903 0 00-.663.27.903.903 0 00-.271.665c0 .262.09.483.27.664.181.18.402.27.665.27zm-.907-3.436h3.203l-1.856-2.461h-1.347v2.46z"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;
